import Hero from './components/Hero';
import Footer from './components/Footer';

export default function HomePage() {
  return (
    <div className="min-h-screen bg-white">
      <Hero />
      <Footer />
    </div>
  );
}
